import 'selectize/dist/js/selectize.min.js';
import owlCarousel from 'owl.carousel';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function() {

	// Pridanie tiena pod navbar
	function scrolled() {
		if ($(window).scrollTop() > 0) {
			$('.nav').addClass('nav--scrolled');
		} else {
			$('.nav').removeClass('nav--scrolled');
		}
	}

	scrolled();

	$(window).on('scroll', function(event) {
		scrolled();
	});

	// Burger
	$('.nav__burger').on('click', function(event) {
		if ($(this).hasClass('nav__burger--active')) {
			$(this).removeClass('nav__burger--active');
			$('.nav__menu').stop().slideUp();
			$('html, body').removeClass('noscroll');
		} else {
			$(this).addClass('nav__burger--active');
			$('.nav__menu').stop().slideDown();
			$('html, body').addClass('noscroll');
		}
	});

	$('.nav-login__link').on('click', function(event) {
		event.preventDefault();
		$('.login').fadeIn(200);
		$('html, body').addClass('noscroll');
	});
	$('.login__close').on('click', function(event) {
		$(this).parents('.login').fadeOut(200);
		$('html, body').removeClass('noscroll');
	});

	$('.cat-item').on('mouseenter', function(event) {
		$(this).addClass('cat-item--active');
	}).on('mouseleave', function(event) {
		$(this).removeClass('cat-item--active');
	});

	$('.news__select').selectize({
		onChange: function(value) {
			$('.news-item').each(function() {
				if (value == 'všetky kategórie') {
					$(this).fadeIn(200);
				} else {
					if (value == $(this).attr('data-category')) {
						$(this).fadeIn(200);
					} else {
						$(this).hide();;
					}
				}
			});
		}
	});
	$('.selectize-input input').attr('readonly', 'readonly');

	$('.cat__select').selectize({
        onChange: function(value) {
            $.get('/odmeny?kategoria=' + value, function(response) {
                $('.page').remove();
                $('.cat__flex').html(response.products);
                $('.cat__flex').after(response.pagination);
            });

            history.pushState({}, 'Odmeny', '/odmeny?kategoria=' + value);
        }
    })

	// Slider fotiek v iznerate
	$('.prod-imgs__slider').owlCarousel({
		items: 3,
		loop: false,
		stagePadding: 20,
		margin: 10,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		nav: false,
		dots: false,
		autoplay: false,
		autoplayTimeout: 0,
		autoplayHoverPause: false,
	});

	$('.prod-imgs__slide').on('click', function(event) {
		$('.prod-imgs__main .prod-imgs__img').attr('src', $(this).children('img').attr('src'));
	});

	// Slider na detailach udalosti
	$('.news-slider__slides').owlCarousel({
		items: 1,
		loop: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		nav: false,
		dots: true,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplayHoverPause: true,
	});
	// Predchadzajuci slide
	$('.news-slider__arrow--left').on('click', function(event) {
		$('.news-slider__slides.owl-carousel').trigger('prev.owl.carousel');
	});
	// Nasledujuci slide
	$('.news-slider__arrow--right').on('click', function(event) {
		$('.news-slider__slides.owl-carousel').trigger('next.owl.carousel');
	});

	$(document).on('click', '.addToCart', function(e) {
	    e.preventDefault();

	    var button = $(this);

        $.ajax({
            type: 'POST',
            url: '/addToCart',
            data: {
                product: $(this).data('product')
            },
            success: function(response) {
                $('.nav-meta__cart').addClass('nav-meta__cart--add');
				$('.nav__cart').addClass('nav__cart--add');
				button.addClass('addToCart--add');
                //košík sa posunie k číslu a keď tam príde tak sa spraví +1 (akože košík priniese nový produkt) [ sa len tak nudím :D ]
                setTimeout(function() {
                    $('.nav-meta__cart').text(response.result);
					$('.nav__badge').text(response.result.split(' ')[0]);
                }, 350);
                setTimeout(function() {
                    $('.nav-meta__cart').removeClass('nav-meta__cart--add');
					$('.nav__cart').removeClass('nav__cart--add');
                }, 520);
				setTimeout(function() {
					button.removeClass('addToCart--add');
				}, 2000);
            }
        });

        return false;
    });

	$(document).on('click', '.order-list__delete', function(e) {
	    e.preventDefault();

	    var $this = $(this);

        $.ajax({
            type: 'POST',
            url: '/removeFromCart',
            data: {
                product: $(this).data('product')
            },
            success: function(response) {
                if(response.reset) {
                    location.reload();
                }

                $this.siblings('.order-list__count').val(0);

                $('.nav-meta__cart').addClass('nav-meta__cart--remove');
				$('.nav__cart').addClass('nav__cart--remove');
                //košík sa posunie od čísla a keď tam príde tak sa spraví -1 (akože košík odnesie nový produkt) [ sa len tak nudím :D ]
                setTimeout(function() {
                    $('.nav-meta__cart').text(response.result);
					$('.nav__badge').text(response.result.split(' ')[0]);
                }, 350);
                setTimeout(function() {
                    $('.nav-meta__cart').removeClass('nav-meta__cart--remove');
					$('.nav__cart').removeClass('nav__cart--remove');
                }, 520);

                $this.parents('.order-list__item').addClass('order-list__item--remove');
                setTimeout(function() {
                    $this.parents('.order-list__item').addClass('order-list__item--absolute');
                }, 800);
                setTimeout(function() {
                    $this.parents('.order-list__item').remove();
                }, 1000);

                refreshTotal();
                //enoughPointsCheck($this);
            }
        });

        return false;
    });

    Number.prototype.format = function(n, x) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\,' : '$') + ')';
        return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&.');
    };

    function refreshTotal(format = true) {
        var $total = 0;
        $('.order-list__count').each(function() {
            $total += $(this).data('value') * $(this).val();
        });

        if(!format) {
            return $total;
        }
        $('.order-list__amount').text($total.format() + ' b.');
    }

    function enoughPointsCheck($this) {
        //Skontrolujeme či má dostatočný počet bodov
        if(refreshTotal(false) >= $('.nav-meta__points').data('points')) {
            $this.addClass('order-list__count--error');
            $('.order-list__not-enough').slideDown();
            $('.nextButton').prop('disabled', true);
        } else {
            $('.order-list__not-enough').slideUp();
            $('.nextButton').prop('disabled', false);
        }
    }

    $(document).on('keyup', '.order-list__count', function(e) {
        var $this = $(this);

        if(! /^([0-9]+)((\.|,)([0-9]{1,2}))?$/.test($this.val())){
            $this.addClass('order-list__count--error');
            return false;
        } else {
            $this.removeClass('order-list__count--error');
            enoughPointsCheck($this);
        }

        $.ajax({
            type: 'POST',
            url: '/updateCount',
            data: {
                product: $this.data('product'),
                count: $this.val()
            },
            success: function(response) {
                if(response.reset) {
                    location.reload();
                }
                if(response.max < $this.val()) {
                    $this.val(response.max);
                }

                //potrebujeme pracovat s nenaformatovanými bodmi tie beriem z data-value a dávame x $this.val()
                $this.siblings('.order-list__total').text(($this.data('value') * $this.val()).format() + ' b.');

                $('.nav-meta__cart').text(response.result);

                refreshTotal();
            }
        });

        return false;
    });

    $('.form__check').change(function() {
        if(!$(this).hasClass('form__check--no')) {
            if ($(this).is(':checked')) {
                $(this).next().removeClass('form__check-label--error');
            } else {
                $(this).next().addClass('form__check-label--error');
            }
        }
    });

    // Taby v zakaznickej zone
	$('.acc__tab').on('click', function(event) {
		event.preventDefault();
		$(this).addClass('acc__tab--active').siblings().removeClass('acc__tab--active');
		var tabId = $(this).attr('data-tab');
		$('.acc__tab-content').each(function() {
			$(this).hide();
			if ($(this).attr('data-tab') == tabId) {
				$(this).fadeIn(200);
			}
		});
	});

	// Harmonika s objednavkou
	$('.order__title').on('click', function(event) {
		$(this).next('.order__content').slideToggle();
		$(this).toggleClass('order__title--active');
	});

    $(window).on('load hashchange', function () {
        //V zakaznickej zone ak máme hash tak je to id objednavky ktorá má byť otvorená
        if(window.location.pathname == '/zakaznicka-zona' && window.location.hash.length > 0) {
            $('.acc__tab[data-tab="1"]').click(); //prepneme na 1. tab
            $('.order__title[data-order="'+window.location.hash+'"]').click(); //vysunieme objednavku
            //scrolneme na objednavku ak by ich bolo viac
            $('html, body').animate({
                scrollTop: $('[data-order="'+window.location.hash+'"]').offset().top
            }, 500);
        }
    });

    $(window).on('scroll', function(event) {
    	if ($(window).scrollTop() > 100) {
    		$('.top').fadeIn();
		} else {
    		$('.top').fadeOut();
		}
	});

    $('.top').on('click', function(event) {
    	$('html, body').animate( {
			scrollTop: 0
		}, 1200);
	});

    // Slider na hompeage
    if($('.h-slider .home-top').length > 1) {
        $('.h-slider').owlCarousel({
            items: 1,
            loop: true,
            stagePadding: 0,
            margin: 0,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            nav: true,
            dots: true,
            autoplay: false,
        });
    }

    function setCookie(key, value) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (120 * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    if (getCookie(window.location.hostname + '_cookie') == null) {
        $('#cookie-privacy').fadeIn(400);
    }
    $('#cookie-privacy .close,#cookie-privacy .ok').click(function (e) {
        e.preventDefault();
        setCookie(window.location.hostname + '_cookie', 'yes');
        $('#cookie-privacy').fadeOut(400);
    });

});
